import React from 'react';

const SkillsForm = ({ data, onChange }) => {
  const addSkillCategory = () => {
    onChange([...data, {
      category: '',
      items: ''
    }]);
  };

  const removeSkillCategory = (index) => {
    const newData = data.filter((_, i) => i !== index);
    onChange(newData);
  };

  const updateSkillCategory = (index, field, value) => {
    const newData = [...data];
    newData[index][field] = value;
    onChange(newData);
  };

  return (
    <div className="form-section">
      <h2 className="section-title">Skills</h2>
      <p className="section-description">
        Organize your skills by category (e.g., Front-End, Back-End, CMS, Mobile Development, Design & Prototyping). 
        Category names are <strong>optional</strong> - you can leave them blank for a general skills list.
        List the most relevant skills for your target position first.
      </p>

      {data.map((skill, index) => (
        <div key={index} className="entry-card">
          <div className="entry-header">
            <span className="entry-number">Skill Category {index + 1}</span>
            {data.length > 1 && (
              <button
                className="remove-button"
                onClick={() => removeSkillCategory(index)}
              >
                Remove
              </button>
            )}
          </div>

          <div className="form-group">
            <label className="form-label">Category Name</label>
            <input
              type="text"
              className="form-input"
              value={skill.category}
              onChange={(e) => updateSkillCategory(index, 'category', e.target.value)}
              placeholder="Programming Languages"
            />
            <p className="form-hint">
              Examples: Front-End, Back-End, CMS, Mobile Development, Design & Prototyping, Other Tools
            </p>
          </div>

          <div className="form-group">
            <label className="form-label required">Skills</label>
            <input
              type="text"
              className="form-input"
              value={skill.items}
              onChange={(e) => updateSkillCategory(index, 'items', e.target.value)}
              placeholder="HTML, CSS, JavaScript, React.js, Bootstrap"
            />
            <p className="form-hint">
              Separate skills with commas. These will be listed under your category above.
            </p>
          </div>
        </div>
      ))}

      <button className="add-button" onClick={addSkillCategory}>
        + Add Another Skill Category
      </button>

      <div className="example-box" style={{
        background: '#f0f7ff',
        padding: '1rem',
        borderRadius: '8px',
        marginTop: '1.5rem',
        fontSize: '0.9rem',
        color: '#2c3e50'
      }}>
        <strong>💡 Example Structure:</strong>
        <div style={{ marginTop: '0.5rem', lineHeight: '1.8' }}>
          <div><strong>Category:</strong> Front-End</div>
          <div><strong>Skills:</strong> HTML, CSS, JavaScript, React.js, Bootstrap</div>
          <div style={{ marginTop: '0.5rem' }}><strong>Category:</strong> Back-End</div>
          <div><strong>Skills:</strong> PHP, MySQL</div>
          <div style={{ marginTop: '0.5rem' }}><strong>Category:</strong> CMS</div>
          <div><strong>Skills:</strong> WordPress, Custom CMS</div>
          <div style={{ marginTop: '0.5rem' }}><strong>Category:</strong> Mobile Development</div>
          <div><strong>Skills:</strong> Flutter</div>
          <div style={{ marginTop: '0.5rem' }}><strong>Category:</strong> Design & Prototyping</div>
          <div><strong>Skills:</strong> Adobe XD, Photoshop, Figma</div>
          <div style={{ marginTop: '0.5rem' }}><strong>Category:</strong> Other Tools</div>
          <div><strong>Skills:</strong> GitHub, CI/CD pipelines, Responsive Web Design, SEO</div>
        </div>
      </div>
    </div>
  );
};

export default SkillsForm;
